<template>
  <Skeleton v-if="!userReady" height="24px" width="24px" class="margin-left-xs" />
  <button v-else-if="isSignedIn" class="grid-x margin-left-xs" data-block-outside-click @click="openMenuWithAccount">
    <i class="icon-24x24 profile"></i>
  </button>
  <div v-else class="relative margin-left-xs">
    <Link :href="Links.account.signIn.url" :tracking="Links.account.signIn.tracking" class="grid-x" @click="useSignInClick">
      <i class="icon-24x24 profile"></i>
    </Link>
    <div v-if="showTooltip" class="guest-tooltip padding-xxs">
      <span class="small">Sign In</span>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
import Link from '~/components/common/Link';
import Links from '#shared/constants/Links';
import useAccount from '~/composables/useAccount';
import useSignInClick from '~/composables/useSignInClick';
import useMenuWithAccount from '~/composables/features/useMenuWithAccount';
import { onUserInit } from '~/events';

const sessionStorageKey = 'mobileSignInTooltipWasShown';

const userReady = ref(false);
const showTooltip = ref(false);
const { isSignedIn } = useAccount();
const { openMenuWithAccount } = useMenuWithAccount();
const showAndCloseTooltipWithDelay = () => {
  showTooltip.value = true;

  setTimeout(() => {
    showTooltip.value = false;
    sessionStorage.setItem(sessionStorageKey, true);
  }, 7000);
};

onUserInit(() => {
  const isTooltipWasDisplayed = sessionStorage.getItem(sessionStorageKey);

  userReady.value = true;

  if (!isSignedIn.value && !isTooltipWasDisplayed) {
    showAndCloseTooltipWithDelay();
  }
});
</script>

<style lang="scss" brand="bcom" scoped>
.profile {
  opacity: 0.42;
}

.guest-tooltip {
  position: absolute;
  top: 100%;
  margin-top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background-color: $css-tooltip-background-color;
  z-index: 2;

  &::before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    left: 50%;
    bottom: 100%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid $css-tooltip-background-color;
  }

  span {
    color: $white;
    white-space: nowrap;
  }
}
</style>
